import {TargetBlank} from '@wandb/weave/common/util/links';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {WANDB_WORKSPACES_DOCS} from '../utils';

type EmptyMessageProps = {
  showClearFilterButton: boolean;
  onClearFilters?: () => void;
};

export const EmptyMessage: React.FC<EmptyMessageProps> = ({
  showClearFilterButton,
  onClearFilters,
}) => {
  if (showClearFilterButton) {
    return (
      <>
        Try adjusting your filters to see more views.
        <button
          onClick={onClearFilters}
          className={twMerge(
            'mt-2 block w-full text-center',
            'font-semibold text-wb-text-link hover:text-wb-text-link-hover'
          )}>
          Clear filters
        </button>
      </>
    );
  }

  return (
    <>
      Save your workspace as a view for future reference or for easy
      collaborative analysis with your teammates.{' '}
      <span>
        <TargetBlank
          href={WANDB_WORKSPACES_DOCS}
          className={twMerge(
            'font-semibold text-wb-text-link hover:text-wb-text-link-hover'
          )}>
          Learn more about views
        </TargetBlank>
      </span>{' '}
      in Docs.
    </>
  );
};
